<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-4">
        <div
          class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov3">
          <base-button
            type="primary"
            class="min-button"
            @click="saveBranch()"
            v-if="canUserCreate"
          >
            <i class="flaticon-floppy-disk icon-no-margin"></i>
            <strong class="d-lg-block d-none">Save</strong>
          </base-button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div class="col-xl-9 col-lg-12 col-md-12">
          <div class="col-12">
            <div class="card">
              <h2 class="subtitle  mb-4">Destination Info</h2>
              <div class="row">
                <div class="col-xl-6 col-lg-8 col-md-6 col-sm-12 col-12">
                  <WSelect
                    v-bind:class="{ 'is-invalid': $v.branch.supplier.$error }"
                    placeholder="Select Supplier"
                    v-model="$v.branch.supplier.$model"
                    id="supplier_name_branch"
                    name="supplier_name_branch"
                    filterable
                    @change="selectOperator"
                    label="Supplier"
                    :error="
                      $v.branch.supplier.$error
                        ? `Minimum ${$v.branch.name.$params.minLength.min} letters.`
                        : ''
                    "
                  >
                    <el-option
                      v-for="supplier in operatorSelections"
                      :value="supplier._id"
                      :label="supplier.businessDetails.name"
                      :key="supplier._id"
                    ></el-option>
                  </WSelect>
                </div>

                <div class="col-xl-6 col-lg-8 col-md-6 col-sm-12 col-12">
                  <WSelect
                    v-bind:class="{ 'is-invalid': $v.destinationSlug.$error }"
                    placeholder="Select Destination"
                    v-model="$v.destinationSlug.$model"
                    id="destination"
                    name="destination"
                    filterable
                    @change="selectDestination"
                    label="Destination"
                    :error="
                      $v.destinationSlug.$error ? `Enter Destination` : ''
                    "
                  >
                    <el-option
                      v-for="(destination, index) in destinationsOptions"
                      :value="destination.slug"
                      :label="destination.city"
                      :key="index"
                    >
                      <span class="hide-data-inline coin-left">{{
                        destination.city
                      }}</span>
                      <span class="hide-data-inline coin-right">{{
                        destination.country.name
                      }}</span>
                    </el-option>
                  </WSelect>
                </div>

                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                  <base-input
                    v-model.trim="$v.branch.first_name.$model"
                    label="First Name"
                    placeholder="First Name"
                    id="branch_firstName"
                    name="branch_firstName"
                    :error="
                      !$v.branch.first_name.minLength ||
                      $v.branch.first_name.$error
                        ? `Minimum ${$v.branch.first_name.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                  <base-input
                    v-model.trim="$v.branch.last_name.$model"
                    id="branch_LastName"
                    name="branch_LastName"
                    label="Last Name"
                    placeholder="Last Name"
                    :error="
                      !$v.branch.last_name.minLength ||
                      $v.branch.last_name.$error
                        ? `Minimum ${$v.branch.last_name.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <base-input
                    v-model.trim="$v.branch.email.$model"
                    id="branch_email"
                    name="branch_email"
                    label="Email Destination"
                    placeholder="example@email.com"
                    :error="
                      !$v.branch.email.email || $v.branch.email.$error
                        ? `Enter a valid email.`
                        : ''
                    "
                  />
                </div>

                <div
                  class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12 inputphone"
                >
                  <label
                    class="title-label"
                    v-bind:class="{
                      'is-invalid': $v.branch.phone.$error
                    }"
                    >Contact Number</label
                  >
                  <vue-tel-input
                    v-model="phone_format"
                    key="NumberPhoneCustomer"
                    inputId="NumberPhoneCustomer"
                    name="NumberPhoneCustomer"
                    required
                    mode="international"
                    inputClasses="input no-label no-err"
                    :dynamicPlaceholder="true"
                    :disabledFetchingCountry="true"
                    :validCharactersOnly="true"
                    :wrapperClasses="[
                      $v.branch.phone.$error ? 'is-invalid' : '',
                      'mb-0'
                    ]"
                    @validate="phoneInput"
                  ></vue-tel-input>
                  <small
                    class="invalid-feedback mt-1"
                    v-if="$v.branch.phone.$error"
                    >Enter a valid phone</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <h2 class="subtitle  mb-4">Address Info</h2>
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-4 col-sm-4 col-12">
                  <base-input
                    v-model.trim="$v.branch.address.$model"
                    id="supplier_address"
                    name="supplier_address"
                    label="Street address, apartment, suite, etc."
                    placeholder="Street address, apartment, suite, etc"
                    :error="
                      !$v.branch.address.minLength
                        ? `Minimum ${$v.branch.address.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                  <WSelect
                    v-bind:class="{ 'is-invalid': $v.branch.city.$error }"
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="getCities"
                    :loading="loading"
                    placeholder="Enter a City"
                    v-model="$v.branch.city.$model"
                    id="branch_city"
                    name="branch_city"
                    label="City"
                    :error="$v.branch.city.$error ? `Enter a City` : ''"
                  >
                    <el-option
                      v-for="(city, index) in optionsCities"
                      :value="city.option"
                      :label="city.option"
                      :key="index"
                    ></el-option>
                  </WSelect>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                  <base-input
                    v-model.trim="$v.branch.state.$model"
                    id="supplier_state"
                    name="supplier_state"
                    label="State/Province/Region"
                    placeholder="State/Province/Region"
                    :error="
                      !$v.branch.state.minLength || $v.branch.state.$error
                        ? `Minimum ${$v.branch.state.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    v-model.trim="$v.branch.zip_code.$model"
                    id="supplier_ZipCode"
                    name="supplier_ZipCode"
                    label="Zip/Postal Code"
                    placeholder="Zip/Postal Code"
                    :error="
                      !$v.branch.zip_code.minLength
                        ? `Minimum ${$v.branch.zip_code.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>

                <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                  <WSelect
                    v-bind:class="{ 'is-invalid': $v.branch.country.$error }"
                    id="supplier_country"
                    name="supplier_country"
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="remoteMethod"
                    :loading="loading"
                    placeholder="Enter a Country"
                    v-model="$v.branch.country.$model"
                    label="Country"
                    :error="$v.branch.country.$error ? `Enter a Country` : ''"
                  >
                    <el-option
                      v-for="country in options"
                      :value="country.name"
                      :label="country.name"
                      :key="country.name"
                    ></el-option>
                  </WSelect>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                  <base-input
                    v-model.trim="$v.branch.address_tow.$model"
                    id="supplier_OtherAddress"
                    name="supplier_OtherAddress"
                    label="Other Address"
                    placeholder="Other Address"
                    :error="
                      !$v.branch.address_tow.minLength
                        ? `Minimum ${$v.branch.address_tow.$params.minLength.min} letters.`
                        : ''
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-12 col-md-12">
          <div class="col-12 p-xl-0">
            <div class="card">
              <h2 class="subtitle  mb-4">Details</h2>
              <div class="row">
                <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                  <WSelect
                    v-bind:class="{
                      'is-invalid': $v.branch.hours_advance_booking.$error
                    }"
                    placeholder="Select hours"
                    v-model="$v.branch.hours_advance_booking.$model"
                    id="branch_Advance"
                    name="branch_Advance"
                    label="Advanced Reservation Minimum"
                    :error="
                      $v.branch.hours_advance_booking.$error
                        ? `Enter Hours`
                        : ''
                    "
                  >
                    <el-option
                      v-for="option in selects_hours"
                      :value="option"
                      :label="option"
                      :key="option"
                    ></el-option>
                  </WSelect>
                </div>
                <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                  <BaseNumberInput
                    v-model.number="$v.branch.selection_range.$model"
                    id="selection_range"
                    name="selection_range"
                    label="Service Coverage Radius"
                    placeholder="Service Coverage Radius"
                    :error="
                      $v.branch.selection_range.$error
                        ? `Minimum 20 Km & Maximum 250 Km.`
                        : ''
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="alinmov2 mb-4">
        <el-tooltip content="Back" placement="bottom">
          <base-button
            type="neutral"
            class="btn-icon-only"
            @click="goToPreviousPage()"
          >
            <i class="flaticon-left-1"></i>
          </base-button>
        </el-tooltip>

        <base-button
          type="primary"
          class="min-button mb-0"
          @click="saveBranch()"
          v-if="canUserCreate"
        >
          <i class="flaticon-floppy-disk"></i>Save Destination
        </base-button>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  alpha,
  numeric
} from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import {
  CountriesAPI,
  BranchesAPI,
  OperatorsAPI,
  DestinationsAPI
} from "../../../core/api";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import lodash from "lodash";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
const ValidateSelectionRange = value => {
  return value >= 20 && value <= 250;
};
export default {
  name: "NewDestinations",
  data() {
    return {
      branch: {
        name: "",
        address: "",
        address_tow: "",
        country: "",
        city: "",
        location: "",
        state: "",
        zip_code: "",
        email: "",
        last_name: "",
        first_name: "",
        phone: "",
        hours_advance_booking: 1,
        supplier: "",
        country_code: "",
        geometry: "",
        selection_range: 45,
        destination: {
          city: "",
          country: {},
          languages: [],
          location: {},
          slug: "",
          state: {},
          time_zone: "",
          iata_code: "",
          geometry: {
            type: "Polygon",
            coordinates: []
          }
        }
      },
      optionsCities: [],
      loading: false,
      options: [],
      phone_format: "",
      selects_hours: [1, 5, 10, 15, 24, 36, 48],
      cancelationsOptions: [1, 12],
      branchCopy: {},
      saved: false,
      destinationsOptions: [],
      destinationSlug: ""
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Destinations",
        to: "/destinations"
      },

      {
        text: "New Destination",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.getOperatorsOptions();
    this.branch.supplier = this.$route.query.operator
      ? this.$route.query.operator
      : "";
    this.branchCopy = Object.assign({}, this.branch);
    this.cancelationsOptions = this.cancelationsOptions.concat(
      Array.from({ length: 30 }, (_, index) => (index + 1) * 24)
    );
    this.destinationsOptions = this.sortByCityName(
      await this.getDestinationsOptions()
    );
  },
  watch: {
    "branch.city": {
      handler: function(current, old) {
        if (current) {
          let city = this.optionsCities.find(city => city.option === current);
          if (city) {
            this.branch.location = city.option;
            this.branch.country_code = city.country_code;
            this.branch.geometry = city.geometry;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    phoneInput(payload) {
      let result = payload;
      if (result.isValid) {
        this.branch.phone = result.number.e164;
      }
    },
    async getCities(input) {
      try {
        if (input !== "" && input.length > 3) {
          this.loading = true;
          let { data } = await CountriesAPI.getCities(input);
          this.loading = false;
          if (data.status) {
            let cities = data.data;
            this.optionsCities = cities;
          } else {
            this.optionsCities = [];
          }
        } else {
          this.optionsCities = [];
        }
      } catch (error) {
        this.optionsCities = [];
      }
    },
    async createBranch(branch, route = null) {
      try {
        this.setLoad(true);
        let { data } = await BranchesAPI.createBranch(
          branch,
          this.sesion.token
        );
        this.saved = true;
        this.setLoad(false);
        if (data.code === 201) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destination has been saved",
            icon: "flaticon-check-3"
          });
          this.$router.push(route ? route : "/destinations");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving the Destination, please try again"
        );
      }
    },
    async saveBranch(route = null) {
      let branch = lodash.cloneDeep(this.branch);
      if (!this.$v.$invalid) {
        await this.createBranch(branch, route);
      } else {
        this.$v.branch.$touch();
        this.$v.destinationSlug.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    async autocompleteAddress(operatorId) {
      try {
        this.setLoad(true);
        let { data } = await OperatorsAPI.getOperatorById(
          operatorId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let branch = data.data;
          this.branch.country = branch.country;
          this.branch.state = branch.state;
          this.branch.address = branch.address;
          this.branch.zip_code = branch.zip_code;
          this.branch.address_tow = branch.address_tow;
          this.branch.phone = branch.phone;
          this.phone_format = branch.phone;
          this.branch.name = branch.name;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.load = false;
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    async selectOperator(operatorId) {
      let { value } = await Swal.fire({
        title: "Duplicate Destination info",
        html: `Are you sure do you want to replicate <span class="capitalize fw-600">${this.getOperatorName(
          operatorId
        )}</span><br> information to this Destination?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.autocompleteAddress(operatorId);
      }
    },
    getOperatorName(operatorId) {
      try {
        let operator = this.operatorSelections.find(
          operator => operator._id === operatorId
        );
        if (operator) {
          return operator.name;
        } else {
          return "";
        }
      } catch (error) {
        return "";
      }
    },
    isInBranchModule(modules = []) {
      if (!(modules.indexOf("destinations") > -1)) {
        this.setBranchSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(from, to, next) {
      let isEqual = lodash.isEqual(this.branch, this.branchCopy);
      if (!isEqual && !this.saved && this.canUserCreate) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Destination has been modified, <br>do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveBranch(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    async getDestinationsOptions() {
      try {
        let { data } = await DestinationsAPI.getDestinationsOptions(
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    selectDestination(slug) {
      if (slug) {
        let destination = this.destinationsOptions.find(
          destination => destination.slug === slug
        );
        this.branch.name = destination.city;
        this.branch.destination = lodash.cloneDeep(destination);
        this.branch.destination.geometry = {
          type: "Polygon",
          coordinates: []
        };
      } else {
        this.branch.name = "";
        this.branch.destination.city = "";
        this.branch.destination.country = {};
        this.branch.destination.languages = [];
        this.branch.destination.location = {};
        this.branch.destination.slug = "";
        this.branch.destination.state = {};
        this.branch.destination.time_zone = "";
        this.branch.destination.iata_code = "";
        this.branch.destination.geometry = {
          type: "Polygon",
          coordinates: []
        };
      }
    },
    sortByCityName(destinations = []) {
      return destinations.sort((a, b) => {
        const firstCity = a.city.toUpperCase();
        const secondCity = b.city.toUpperCase();
        if (firstCity < secondCity) {
          return -1;
        }
        if (firstCity > secondCity) {
          return 1;
        }
        return 0;
      });
    },
    getTimeFormat(time) {
      if (time >= 1 && time <= 12) {
        return time === 1 ? `${time} hour` : `${time} hours`;
      } else {
        return time / 24 === 1 ? `${time / 24} day` : `${time / 24} days`;
      }
    },
    ...mapActions(["getOperatorsOptions"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setBranchSearchCriteria"
    ])
  },
  computed: {
    ...mapGetters([
      "operatorSelections",
      "countries",
      "sesion",
      "userRole",
      "sigout",
      "settings"
    ]),
    canUserCreate() {
      return isUserAuthorized("DESTINATIONS", this.userRole, "CREATE");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInBranchModule(to.meta.modules);
    if (!this.sigout) {
      this.detectChanges(to, from, next);
    } else {
      next();
    }
  },
  validations: {
    branch: {
      name: {
        required,
        minLength: minLength(4)
      },
      address: {
        minLength: minLength(8)
      },
      address_tow: {
        minLength: minLength(8)
      },
      country: {
        required,
        minLength: minLength(3)
      },
      city: {
        required,
        minLength: minLength(3)
      },
      state: {
        required,
        minLength: minLength(3)
      },
      zip_code: {
        minLength: minLength(4)
      },
      email: {
        required,
        email
      },
      last_name: {
        required,
        minLength: minLength(2),
        maxlength: maxLength(45),
        ValName
      },
      first_name: {
        required,
        minLength: minLength(2),
        maxlength: maxLength(45),
        ValName
      },
      phone: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(15)
      },
      hours_advance_booking: {
        required
      },
      selection_range: {
        required,
        numeric,
        ValidateSelectionRange
      },
      supplier: {
        required,
        minLength: minLength(4)
      }
    },
    destinationSlug: {
      required
    }
  },
  components: {
    VueTelInput,
    WSelect
  }
};
</script>
